import React, { PureComponent } from 'react'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import LOGO from 'public/assets/svg/Logo_01.svg'
import './loadingScreen.scss'
import LoadingIndicator from '../components/LoadingIndicator'

const ScreenStyle = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'black',
    zIndex: 3000,
    transform: 'translate3d(0, 0, 1px)',
    fontSize: 1,
}

const PositionStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
}

const LoaderPositionStyle = {
    width: '50vw',
    height: '50vw',
    position: 'relative',
    marginBottom: 50,
}

const ImageStyle = {
    width: '50vw',
}

const SpinnerWrap = {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '25vw',
    height: '25vw',
    position: 'absolute',
}

class LoadingScreen extends PureComponent {
    static defaultProps = {
        style: {},
    }

    constructor(props) {
        super(props)

        this.renderChild = this.renderChild.bind(this)
    }

    renderChild() {
        const {
            style: { screen, position, loaderPosition, image, spinner },
        } = this.props

        return (
            <div
                style={{
                    ...ScreenStyle,
                    ...screen,
                }}
                aria-label="Experience loading"
                alt="Experience loading"
            >
                <div
                    style={{
                        ...PositionStyle,
                        ...position,
                    }}
                >
                    <div
                        style={{
                            ...LoaderPositionStyle,
                            ...loaderPosition,
                        }}
                    >
                        <LoadingIndicator
                            style={{
                                spinner: {
                                    ...SpinnerWrap,
                                    ...spinner,
                                },
                            }}
                        />
                    </div>
                    <img
                        style={{
                            ...ImageStyle,
                            ...image,
                        }}
                        src={LOGO}
                        aria-label="Experience loading"
                    />
                </div>
            </div>
        )
    }
    render() {
        const {
            props: { loading },
        } = this
        return <OpacityHelper test={loading}>{this.renderChild}</OpacityHelper>
    }
}

export default LoadingScreen
